// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"a45eee56","827":"ca58777c"}[chunkId] + ".chunk.js";
};